import getDB from './util/getDB';

// maps taskIds onto an object consisting of date keys that in turn map onto offline Entity Submits
export const offlineTaskToEntityKeyVal = getDB<{
    [submissionDate: string]: true;
}>('OfflineTaskToEntityKeyMap', 1, 'keymap');
